import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstatePropStats } from 'redux/realEstateSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';

const PauseModal = ({ property, setShow, handleStatus }) => {
  const handleClose = () => setShow(false);

  const { realEstate } = useSelector(state => state.realEstate);
  const dispatch = useDispatch();

  const handlePause = async prop => {
    await handleStatus(prop);
    dispatch(getRealEstatePropStats(realEstate.id));
    handleClose();
  };

  return (
    <>
      <Modal
        keyboard={true}
        show={true}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <FontAwesomeIcon
            icon="fa-pause"
            title="Pausar"
            size="1x"
            style={{ marginRight: 8, color: '#02a8b5' }}
          />

          <Modal.Title>Pausar propiedad</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-4">
            La propiedad de dirección{' '}
            <b>
              {property.location.street} {property.location.number}
            </b>{' '}
            se pausará y ya no será visible por los clientes.
            <br />
            <br />
            ¿Está seguro de confirmar esta acción?
          </div>

          <ModalButtonsContainer>
            <ButtonClose
              text="Cancelar"
              funcion={handleClose}
              variant="secondary"
            />

            <ButtonAccept
              text="Pausar"
              funcion={handlePause}
              data={{ id: property._id, status: 'paused' }}
            />
          </ModalButtonsContainer>
        </Modal.Body>
      </Modal>
    </>
  );
};

PauseModal.propTypes = {
  property: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  handleStatus: PropTypes.func.isRequired
};

export default PauseModal;
